import './index.css';
import { Header, ScreenBackground, View, Text, RouteWrapper } from '../../../component';
import { useLink } from 'react-router-stack';
import useTheme from '../../../utilities/hooks/theme';
import { useDispatch, useSelector } from 'react-redux';
import { changeTheme } from '../../../actions/setting-actions-types';
import RadioGroup from '@mui/material/RadioGroup/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel/FormControlLabel';
import Radio from '@mui/material/Radio/Radio';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { ChangeEvent } from 'react';

const Settings = () => {
  const { MoreTheme } = useTheme();
  const navigate = useLink();
  const setting = useSelector((state: any) => state.setting);
  const { themeType } = setting;
  const dispatch = useDispatch();

  const radiosSx: SxProps<Theme> = {
    '& .MuiTypography-root': {
      fontSize: 'small',
      fontFamily: 'ProximaNova-Regular',
      color: MoreTheme.editProfileLabel
    }
  };

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const handleRadioChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(changeTheme((event.target as HTMLInputElement).value));
  };

  const labelColor = {
    color: MoreTheme.editProfileLabel
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header title={'Settings'} onClickBack={onClickBack} />
        <View className={'settings-container'}>
          <View className={'settings-item-container'}>
            <Text style={labelColor} className={'settings-item-title'}>
              {'Theme'}
            </Text>
            <RadioGroup
              sx={radiosSx}
              style={{
                backgroundColor: MoreTheme.settingOptionBackground,
                paddingLeft: '15px',
                paddingRight: '15px',
                borderRadius: '10px'
              }}
              defaultValue="light"
              row
              className={'settings-item-radio-container'}
              value={themeType.toLowerCase()}
              onChange={handleRadioChange}>
              <FormControlLabel value="light" control={<Radio />} label="Light" />
              <FormControlLabel value="dark" control={<Radio />} label="Dark" />
              {/* <FormControlLabel value="system_default" control={<Radio />} label="System Default" /> */}
            </RadioGroup>
          </View>
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default Settings;
